import {Component} from '@angular/core';
import {RouterOutlet} from '@angular/router';


@Component({
  selector: 'app-market-analysis',
  templateUrl: './market-analysis.component.html',
  imports: [
    RouterOutlet
  ]
})
export default class MarketAnalysisComponent {

}
